import { build } from '@s20/common/util/url';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes, ContactTypes } from '../Common';

export const getCompanyContactsOptions = async (
    companyId,
    constrainContactTypes,
    requestedById,
    foremanId,
    projectManagerId,
) => {
    // The contact-type constraint (per the tenant's ConstrainContactTypesOnJob
    // setting) is applied server-side. We forward the intent plus any already
    // assigned contacts that must remain selectable even if their type is excluded.
    // build drops null/undefined entries, so optional params can be left
    // unset here without emitting `key=undefined`.
    const params = {
        constrain: constrainContactTypes,
        requestedById,
        foremanId,
        projectManagerId,
    };

    // Every param here is optional, so params can be empty. build returns
    // an empty string (dropping the url) when given no params, so fall back to the
    // bare base url in that case.
    const baseUrl = ApiRoutes.company.contacts(companyId);
    const companyContacts = await httpClient.js(build(baseUrl, params) || baseUrl);

    const activeContacts = companyContacts.filter((c) => c.isActive);

    const contactsMapped = activeContacts.map((x) => ({
        label: x.contactName,
        value: x.id,
    }));
    const projectManagersMapped = activeContacts
        .filter((c) => c.locationContactTypes?.some((t) => t.id === ContactTypes.ProjectManager))
        .map((x) => ({
            label: x.contactName,
            value: x.id,
        }));

    return { companyContactsOptions: contactsMapped, projectManagerContactOptions: projectManagersMapped };
};